module.exports = __webpack_public_path__ + "static/media/015.f32d3ba9.jpg";